import { OrderList } from "../../orders/types/orderTypes";

export const useOrderStats = (orders: OrderList[]) => {
  const total = orders.length;
  const pending = orders.filter((o) => o.OrderStatus === "pending").length;
  const completed = orders.filter((o) => o.OrderStatus === "Completed").length;
  const cancelled = orders.filter((o) => o.OrderStatus === "Cancelled").length;
  return { total, pending, completed, cancelled };
};
